import React, { useState } from 'react';
import { Loader2, Send } from 'lucide-react';
import { toast } from 'sonner';
import { Card, inputCls, goldBtn } from '../ui';
import { api, eur, errMsg } from '../api';

const KINDS = [['person', 'Persona fisica', 'Codice fiscale (16 caratteri)'], ['company', 'Persona giuridica', 'Partita IVA (11 cifre)']];

export default function RequestForm({ initial, enabled, price, onDone }) {
  const [form, setForm] = useState({ name: initial.name || '', kind: initial.kind === 'company' ? 'company' : 'person', code: initial.code || '' });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/property/requests', form);
      toast.success('Visura richiesta: la ricerca è partita');
      onDone();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const ph = KINDS.find((k) => k[0] === form.kind)[2];
  return (
    <Card className="p-6 mb-6" data-testid="immobili-request-form">
      <p className="text-[11px] uppercase tracking-[0.18em] text-[#5A5F67] mb-4">Richiedi visura catastale nazionale</p>
      <form onSubmit={submit} className="grid gap-3 md:grid-cols-[1.4fr_auto_1fr_auto] items-end">
        <input className={`${inputCls} w-full px-3 border`} placeholder="Nominativo o ragione sociale" value={form.name} onChange={set('name')} required minLength={2} data-testid="immobili-name-input" />
        <div className="flex border border-[#1F242C] rounded-sm h-11 overflow-hidden" data-testid="immobili-kind-toggle">
          {KINDS.map(([k, l]) => (
            <button type="button" key={k} onClick={() => setForm({ ...form, kind: k })} className={`px-3 text-xs transition-colors ${form.kind === k ? 'bg-[#D4AF37] text-[#050505]' : 'text-[#8A8F97] hover:text-[#E5E5E5]'}`} data-testid={`immobili-kind-${k}`}>{l}</button>
          ))}
        </div>
        <input className={`${inputCls} w-full px-3 border font-mono uppercase`} placeholder={ph} value={form.code} onChange={set('code')} required data-testid="immobili-code-input" />
        <button type="submit" disabled={!enabled || busy} className={`${goldBtn} h-11 px-5 inline-flex items-center justify-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed`} data-testid="immobili-request-btn">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />}
          {enabled ? `Richiedi${price != null ? ` · ${eur(price)}` : ''}` : 'In attivazione'}
        </button>
      </form>
      <p className="text-xs text-[#5A5F67] mt-3">Ricerca su tutto il territorio nazionale (escluse le province di Trento e Bolzano, che hanno un catasto proprio). Il documento è prodotto dall'Agenzia delle Entrate e compare qui appena pronto; ti avvisiamo anche via email.</p>
    </Card>
  );
}
